/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@package/api-client/client-config";
import type { ListAppsQueryResponse, ListAppsPathParams } from "../../types/appsController/ListApps.ts";
import type { RequestConfig, ResponseErrorConfig } from "@package/api-client/client-config";

function getListAppsUrl(orgId: ListAppsPathParams["orgId"]) {
  const res = { method: 'GET', url: `/api/organizations/${orgId}/apps/` as const }  
  return res
}

/**
 * @summary List apps for organization
 * {@link /api/organizations/:orgId/apps/}
 */
export async function listApps(orgId: ListAppsPathParams["orgId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ListAppsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getListAppsUrl(orgId).url.toString(), ... requestConfig })  
  return res.data
}